import _ from 'lodash';
import React, { useState } from 'react';

const AddEntityDialog = ({ onClose, onSubmit }) => {
	const [formData, setFormData] = useState({
		taxId: '',
		entityName: '',
		notes: '',
		status: 'BLOCKED'
	});
	const [errors, setErrors] = useState({});

	const validateField = (fieldName, fieldValue) => {
		fieldValue = fieldValue.trim();
		let errorMessage = '';
		if (['notes'].includes(fieldName)) {
			return '';
		}
		if (!fieldValue) {
			return `${_.startCase(fieldName.split('.').at(-1))} is required`;
		}
		switch (fieldName) {
			case 'taxId':
				if (!/^[0-9]{9}$/.test(fieldValue)) {
					errorMessage = 'Tax ID should be numeric and exactly 9 digits';
				}
				break;
		}
		return errorMessage;
	};

	const validateForm = () => {
		const errors = {};
		for (const fieldName in formData) {
			const errorMessage = validateField(fieldName, formData[fieldName]);
			if (errorMessage) {
				errors[fieldName] = errorMessage;
			}
		}
		return errors;
	};

	const handleChange = e => {
		const { name, value } = e.target;

		setFormData(prevFormData => ({
			...prevFormData,
			[name]: value
		}));

		if (errors[name]) {
			const error = validateField(name, value);

			if (!error) {
				const newErrors = { ...errors };
				delete newErrors[name];
				setErrors(newErrors);
			}
		}
	};

	const handleBlur = e => {
		const { name, value } = e.target;

		const errorMessage = validateField(name, value);
		if (errorMessage) {
			setErrors(prevErrors => {
				const updatedErrors = {
					...prevErrors,
					[name]: errorMessage
				};
				return updatedErrors;
			});
		}
	};

	const handleSubmit = e => {
		const newErrors = validateForm();
		if (Object.keys(newErrors).length) {
			setErrors(newErrors);
			return;
		}
		onSubmit(formData);
	};

	return (
		<div className={'overlayDialog visible'} id="addEntityOverlayDialog">
			<div className="blackoutLayer" onClick={onClose}></div>
			<div className="overlayDialogWindow">
				<a className="closeButton" onClick={onClose}>
					×
				</a>
				<div>
					<h2 className="title">Add Entity</h2>
				</div>
				<form className="addEntityForm">
					<section className="addEntityFormGrid smallPush">
						<div className="addEntityFormInputGroup">
							<label htmlFor="taxId">
								<b>Tax ID:</b>
							</label>
							<div>
								<input id="taxId" type="text" name="taxId" className="fullWidth" value={formData.taxId} onChange={handleChange} onBlur={handleBlur} />
								{errors.taxId && (
									<p className="small red my-0">
										<small>{errors.taxId}</small>
									</p>
								)}
							</div>
						</div>
						<div className="addEntityFormInputGroup">
							<label htmlFor="entityName">
								<b>Entity Name:</b>
							</label>
							<div>
								<input
									id="entityName"
									type="text"
									name="entityName"
									className="fullWidth"
									value={formData.entityName}
									onChange={handleChange}
									onBlur={handleBlur}
								/>
								{errors.entityName && (
									<p className="small red my-0">
										<small>{errors.entityName}</small>
									</p>
								)}
							</div>
						</div>
						{/* <div className="addEntityFormInputGroup">
							<label htmlFor="status">
								<b>Status:</b>
							</label>
							<div>
								<select id="status" type="text" name="status" className="fullWidth" value={formData.status} onChange={handleChange}>
                  <option value="BLOCKED">Blocked</option>
                  <option value="UNBLOCKED">Unblocked</option>
                  </select>
							</div>
						</div> */}
						<div className="addEntityFormInputGroup">
							<label htmlFor="notes">
								<b>Notes:</b>
							</label>
							<textarea id="notes" className="fullWidth" name="notes" value={formData.notes} onChange={handleChange} />
						</div>
					</section>
					<div className="flex justify-end">
						<button type="button" onClick={handleSubmit}>
							Add
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};
export default AddEntityDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/addEntityDialog.jsx